/**
 * Resolve the API base URL.
 *
 * Architecture: split-domain.
 *   Frontend → www.verumq.com (Vercel)
 *   Backend  → api.verumq.com (Render)
 *
 * REACT_APP_BACKEND_URL is set at build time in Vercel to
 * `https://api.verumq.com` and is the single source of truth.
 *
 * Cross-origin auth cookies must be configured server-side as
 * SameSite=None; Secure for the cookie to survive across the
 * frontend↔backend origin boundary. The backend's set_cookie call
 * already handles this in production.
 *
 * History: pre-DNS-cut, this file had a runtime fallback that
 * collapsed to same-origin if the configured backend differed from
 * window.location.origin. That logic only made sense when the
 * intended deploy was a single-origin proxy (Vercel rewrites
 * /api/* → backend). With a split-domain deploy on the new
 * verumq.com architecture, that fallback caused the wrong endpoint
 * to be hit and was removed 2026-05-06.
 */
export const API_URL = process.env.REACT_APP_BACKEND_URL || '';
